import styled from "styled-components";
import { THEME } from "../../constant";

export const Layout = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 5px solid ${THEME.kucc};
`;

export const InnerContent = styled.div`
  width: 100%;
  max-width: 1020px;
  padding-bottom: 10rem;
`;
